import { render } from "./TrendingPage.vue?vue&type=template&id=27178ada"
import script from "./TrendingPage.vue?vue&type=script&lang=js"
export * from "./TrendingPage.vue?vue&type=script&lang=js"
script.render = render

export default script